import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [
		// {
		// 	path: '/',
		// 	name: 'login1',
		// 	component: () => import('@/pages/login1')
		// },
		{
			path: '/',
			name: 'loginSchool1',
			component: () => import('@/pages/loginSchool1')
		},
		{
			path: '/pages/loginSchool1',
			name: 'loginSchool1',
			redirect: '/'
		},
		{
			path: '/pages/coursewareInfoPdfLink1',
			name: 'coursewareInfoPdfLink1',
			component: () => import('@/pages/coursewareInfoPdfLink1')
		},
		{
			path: '/pages/coursewareInfoWindows',
			name: "coursewareInfoWindows",
			component: () => import('@/pages/coursewareInfoWindows')
		},
		{
			path: '/pages',
			name: 'pages',
			component: () => import('@/pages/main'),
			children: [
				{
					path: '/pages/coursewareInfoLink1',
					name: 'coursewareInfoLink1',
					component: () => import('@/pages/coursewareInfoLink1')
				},
				{
					path: '/pages/coursewareInfoVideoLink1',
					name: 'coursewareInfoVideoLink1',
					component: () => import('@/pages/coursewareInfoVideoLink1')
				},
				
				{
					path: '/pages/welcom1',
					name: 'welcom1',
					component: () => import('@/pages/welcom1')
				},
				{
					path: '/pages/school1',
					name: 'school1',
					component: () => import('@/pages/school1')
				},
				{
					path: '/pages/subject1',
					name: 'subject1',
					component: () => import('@/pages/subject1')
				},
				{
					path: '/pages/Courseware1',
					name: 'Courseware1',
					component: () => import('@/pages/Courseware1')
				},
				{
					path: '/pages/CoursewareTwo1/:id',
					name: 'CoursewareTwo1',
					component: () => import('@/pages/CoursewareTwo1')
				},
				{
					path: '/pages/CoursewareThree1',
					name: 'CoursewareThree1',
					component: () => import('@/pages/CoursewareThree1')
				},
				{
					path: '/pages/CoursewareFour1',
					name: 'CoursewareFour1',
					component: () => import('@/pages/CoursewareFour1')
				},
				{
					path: '/pages/courseInfo1',
					name: 'courseInfo1',
					component: () => import('@/pages/courseInfo1')
				},
				{
					path: '/pages/teacherBack1',
					name: 'teacherBack1',
					component: () => import('@/pages/teacherBack1')
				},
				{
					path: '/pages/Administrator1',
					name: 'Administrator1',
					component: () => import('@/pages/Administrator1')
				},
				{
					path: '/pages/role1',
					name: 'role1',
					component: () => import('@/pages/role1')
				},
				{
					path: '/pages/foundational1',
					name: 'foundational1',
					component: () => import('@/pages/foundational1')
				},
				{
					path: '/pages/check1',
					name: 'check1',
					component: () => import('@/pages/check1')
				},
				{
					path: '/pages/message1',
					name: 'message1',
					component: () => import('@/pages/message1')
				},
				{
					path: '/pages/coursewareLog1',
					name: 'coursewareLog1',
					component: () => import('@/pages/coursewareLog1')
				}
			]
		},
	]
	
})



// WEBPACK FOOTER //
// ./src/router/index.js